import { baseUrl } from '@/config/env'
import useRequest from '@/composables/use-request'
import type { Pagination } from '@/types/interfaces'
import type { NoticeStatus } from '@/types/modules/views'

const { post } = useRequest()

export interface NoticeContent {
  title: string // 标题
  content: string // 内容
}

export interface Notice {
  id: string
  versionNumber: string // 版本号
  portal: string // 所属门户
  reminderPosition: string // 提醒位置
  reminderCycle: number // 提醒周期
  url: string // 公告链接
  mustRead: boolean // 是否必读
  hasFunctionGuide: boolean // 是否有功能引导
  status: string // 状态
  image: string // 图片
  content: NoticeContent[] // 内容
  createdAt?: string // 创建时间
}

export interface CreateNoticeReq {
  versionNumber: string // 版本号
  portal: string // 所属门户
  reminderPosition: string // 提醒位置
  reminderCycle: number // 提醒周期
  url: string // 公告链接
  mustRead: boolean // 是否必读
  hasFunctionGuide: boolean // 是否有功能引导
  status: string // 状态
  image: string // 图片
  content: string // 内容
}

export interface CreateNoticeResp {
  id: string // 公告ID
}

export interface UpdateNoticeReq {
  id: string // 公告ID
  versionNumber: string // 版本号
  portal: string // 所属门户
  reminderPosition: string // 提醒位置
  reminderCycle: number // 提醒周期
  url: string // 公告链接
  mustRead: boolean // 是否必读
  hasFunctionGuide: boolean // 是否有功能引导
  status: string // 状态
  image: string // 图片
  content: string // 内容
}

export interface UpdateNoticeResp {}

export interface DeleteNoticeReq {
  id: string // 公告ID
}

export interface DeleteNoticeResp {}

export interface ListNoticeReq {
  page: Pagination // 分页
  fuzzyVersionNumber: string // 版本号模糊查询
  fuzzyPortal: string // 所属门户模糊查询
  ReminderPosition: string // 提醒位置
  mustReadFlag: boolean // 是否必读标记
  mustRead?: boolean | NoticeStatus // 是否必读
  hasFunctionGuideFlag: boolean // 是否有功能引导标记
  hasFunctionGuide?: boolean | NoticeStatus // 是否有功能引导
  status?: string // 状态
}

export interface ListNoticeResp {
  total: number
  noticeList: Notice[] // 公告列表
}

export interface GetLatestNoticeReq {
  status: string // 状态
}

export interface GetLatestNoticeResp {
  data: Notice // 公告
}

export const SystemService = {
  // 创建公告
  async createNotice(params: CreateNoticeReq) {
    return await post<CreateNoticeResp>(`${baseUrl}/message/create/notice`, params)
  },
  // 更新公告
  async updateNotice(params: UpdateNoticeReq) {
    return await post<UpdateNoticeResp>(`${baseUrl}/message/update/notice`, params)
  },
  // 删除公告
  async deleteNotice(params: DeleteNoticeReq) {
    return await post<DeleteNoticeResp>(`${baseUrl}/message/delete/notice`, params)
  },
  // 获取公告列表
  async listNotice(params: ListNoticeReq) {
    return await post<ListNoticeResp>(`${baseUrl}/message/list/notice`, params)
  },
  // 获取最新公告
  async getLatestNotice(params: GetLatestNoticeReq) {
    return await post<Notice>(`${baseUrl}/message/getLatestNotice`, params)
  },
}
